<template>
  <div class="home">

    <!-- Encabezado de la Aplicación -->
    <div class="appHeader bg-primary text-light">
        <div class="left">
            <a href="#" class="headerButton" data-bs-toggle="modal" data-bs-target="#sidebarPanel">
                <ion-icon name="menu-outline"></ion-icon>
            </a>
        </div>
        <div class="pageTitle">
            <img src="@/assets/img/logo.png" alt="logo" class="logo"> 
            Sombrero Wallet
        </div>
        <div class="right">
          <!-- <router-link :to="{ name: 'notifications' }" class="headerButton">
                <ion-icon class="icon" name="notifications-outline"></ion-icon>
                <span class="badge badge-danger">4</span>
          </router-link> -->
          <!-- <router-link :to="{ name: 'settings' }" class="headerButton">
                <img src="@/assets/img/sample/avatar/avatar1.jpg" alt="image" class="imaged w32">
                <span class="badge badge-danger">6</span>
          </router-link> -->
          <a href="/settings" class="headerButton">
            <ion-icon name="settings-outline"></ion-icon>
            <!-- <img src="@/assets/img/sample/avatar/avatar1.jpg" alt="image" class="imaged w32">
            <span class="badge badge-danger">6</span> -->
          </a>

        </div>
    </div>
    <!-- * Encabezado de la Aplicación -->

    <!-- Cápsula de la Aplicación -->
    <div id="appCapsule">
      <wallet-card-section />
      
        <!-- Estadísticas -->
        <!-- <div class="section">
            <div class="row mt-2">
                <div class="col-6">
                    <div class="stat-box">
                        <div class="title">Ingresos</div>
                        <div class="value text-success">$ 552.95</div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="stat-box">
                        <div class="title">Gastos</div>
                        <div class="value text-danger">$ 86.45</div>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-6">
                    <div class="stat-box">
                        <div class="title">Total de Facturas</div>
                        <div class="value">$ 53.25</div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="stat-box">
                        <div class="title">Ahorros</div>
                        <div class="value">$ 120.99</div>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- * Estadísticas -->

      <portafolio-card-section />
      <!-- <transactions-card-section /> -->
      <history-card-section />

        
        <!-- Deslizador -->
        <div class="section mt-4 mb-3 full">
            <!-- <div class="section-heading ms-3">
                <h2 class="title">Muy Pronto</h2>
            </div> -->
            <div class="carousel-single splide">
                <div class="splide__track">
                    <ul class="splide__list">

                        <!-- <li class="splide__slide">
                            <div class="card card-with-icon">
                                <div class="card-body pt-3 pb-3 text-center">
                                    <div class="card-icon bg-success mb-2">
                                        <ion-icon name="link"></ion-icon>
                                    </div>
                                    <h3 class="card-titlde mb-1">Recomienda a un amigo</h3>

                                    <p>¡Invita a tus amigos y gana premios!</p>
                                    <div class="row">
                                        <div class="col">
                                            <button disabled="" href="/refer" class="btn btn-secondary disabled">
                                                <ion-icon name="copy-outline"></ion-icon>
                                                Invitar ahora
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li> -->

                        <li class="splide__slide">
                            <div class="card card-with-icon">
                                <div class="card-body pt-3 pb-3 text-center">
                                    <div class="card-icon mb-2">
                                        <ion-icon name="chatbox-ellipses"></ion-icon>
                                    </div>
                                    <h3 class="card-titlde mb-1">¿Necesitas Ayuda?</h3>

                                    <p>¡Hablemos sobre ello!</p>
                                    <div class="row">
                                        <div class="col">
                                            <a href="http://ayuda.sombrerowallet.com/" target="_blank" class="btn btn-block btn-primary">
                                                Soporte y Ayuda
                                            </a>
                                        </div>
                                        <div class="col">
                                            <a href="https://ayuda.sombrerowallet.com/knowledgebase.php" target="_blank" class="btn btn-block btn-secondary">
                                                Tutoriales
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <!-- <li class="splide__slide">
                            <div class="card card-with-icon">
                                <div class="card-body pt-3 pb-3 text-center">
                                    <div class="card-icon bg-secondary mb-2">
                                        <ion-icon name="share-social-outline"></ion-icon>
                                    </div>
                                    <h3 class="card-titlde mb-1">Síguenos</h3>

                                    <p>¡Síguenos en las redes sociales!</p>
                                    <div class="row">
                                        <div class="col">
                                            <a href="#" target="_blank" class="btn btn-block btn-facebook">
                                                <ion-icon name="logo-facebook"></ion-icon>
                                                Facebook
                                            </a>
                                        </div>
                                        <div class="col">
                                            <a href="#" target="_blank" class="btn btn-block btn-twitter">
                                                <ion-icon name="logo-twitter"></ion-icon>
                                                Twitter
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li> -->

                    </ul>
                </div>
            </div>
        </div>
        <!-- * Deslizador -->

        <footer-default />
        <!-- pie de página de la aplicación -->
        <div class="appFooter">
            <div class="footer-title">
                Copyright © SombreroWallet 2024. Todos los derechos reservados.
            </div>
            Un Desarrollo creado en Colombia
        </div>
        <!-- * pie de página de la aplicación -->

    </div>
    <!-- * App Capsule -->

    <default-button-menu />

    <default-sidebar />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
  name: 'HomeView',
  data() {
    return {
      networks: [],
      currencies: [],
      assets: [],
      form: {
        network: 0,
        asset: 0,
      }
    };
  },
  matches: {
    'form.network'() {
      this.form.asset = 0;
    }
  },
  computed: {
    ...mapState(['userData', 'balance', 'last']),
  },
  async mounted() {
    this.$root.loadBackButtom();
    this.$root.loadInputs();
    // const networks = await this.networksAPI();
    // console.log('networks', networks.networks)
    // this.networks = networks.networks

    // const currencies = await this.currenciesAPI();
    // console.log('currencies', currencies.currencies)
    // this.currencies = currencies.currencies

    this.loadC()
  },
  methods: {
    ...mapActions(['logoutAPI', 'networksAPI', 'currenciesAPI']),
    loadC() {
      // eslint-disable-next-line
      document.querySelectorAll('.carousel-single').forEach(carousel => new Splide(carousel, {
          perPage: 3,
          rewind: true,
          type: "loop",
          gap: 16,
          padding: 16,
          arrows: false,
          pagination: false,
          breakpoints: {
              768: {
                  perPage: 1
              },
              991: {
                  perPage: 2
              }
          }
      }).mount());
    }
  },
}
</script>
